import script from "./CreateAccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAccountModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateAccountModal.vue?vue&type=style&index=0&id=2d358ba0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d358ba0"]])

export default __exports__